<template>
  <main class="wrap">
    <section class="page">
      <div class="top-area">
        <div class="bg"></div>
      </div>
      <img class="dial-base" src="./static/images/bind-device-v2/Group421.png" alt="">
      <div class="dial-ring" aria-hidden="true">
        <svg viewBox="0 0 200 200" preserveAspectRatio="xMidYMid meet" role="img" aria-label="">
          <circle class="ring-track" cx="100" cy="100" r="68" fill="none" stroke-width="16" />
          <circle class="ring-progress" cx="100" cy="100" r="68" fill="none" stroke-width="12" :style="ringStyle" />
        </svg>
      </div>
      <p class="used">已使用流量</p>
      <p class="percent">{{ p.toFixed(2) }}%</p>
      <p class="remain">剩余流量：{{ remainUsage }}G</p>

      <div class="info-panel"></div>
      <div class="row-divider d1" aria-hidden="true"></div>
      <div class="row-divider d2" aria-hidden="true"></div>
      <div class="row-divider d3" aria-hidden="true"></div>
      <p class="label l1">设备卡号：</p><p class="value v1">{{ iccid }}</p>
      <p class="label l2">当前套餐：</p><p class="value v2">{{ packageName || "当前没有套餐" }}</p>
      <p class="label l3">运营状态：</p><p class="value v3">{{ simStatusName || "--" }}</p>

      <button class="charge-btn" type="button" @click="$router.push({name:'recharge',query:{iccid:iccid}})">充值</button>
    </section>
  </main>
</template>

<script>
export default {
  name: "usageNew",
  data () {
    return { iccid: "", simStatusName: "", simAuthStatus: "", totalUsage: 0, remainUsage: 0, usedUsage: 0, packageName: "" }
  },
  computed: {
    p () {
      if (!this.totalUsage) return 0
      return parseFloat(((this.usedUsage / this.totalUsage) * 100).toFixed(2))
    },
    ringStyle () {
      const r = 68
      const c = 2 * Math.PI * r
      const val = Math.min(1, Math.max(0, this.p / 100))
      return { strokeDasharray: `${c.toFixed(2)} ${c.toFixed(2)}`, strokeDashoffset: (c * (1 - val)).toFixed(2) }
    }
  },
  methods: {
    queryCardStatus () {
      this.$toast.loading({ message: "加载中", duration: 0 })
      this.fetchData("/card/status", { iccid: this.iccid }, (res) => {
        this.$toast.clear()
        if (!res.code) return this.$toast.fail(res.msg)
        this.simStatusName = res.data.simStatusName
        this.simAuthStatus = res.data.simAuthStatus
        this.totalUsage = res.data.total
        this.remainUsage = res.data.remain
        this.usedUsage = res.data.used
      })
    },
    getNowPackage () {
      this.fetchData("/package/getNowPackage", { iccid: this.iccid }, (res) => {
        if (res.code) this.packageName = res.data
      })
    }
  },
  created () {
    this.iccid = this.$route.query.iccid
    this.queryCardStatus()
    this.getNowPackage()
  }
}
</script>

<style scoped>
* { box-sizing: border-box; }
body { margin: 0; }
.wrap { width: 100%; max-width: 3.76rem; margin: 0 auto; }
.page { width: 3.76rem; height: 7.24rem; position: relative; overflow: hidden; background: #fff; }
.top-area { position: absolute; left: 0; top: 0; width: 3.76rem; height: 3.60rem; overflow: hidden; }
.top-area::before { content: ""; position: absolute; display: block; width: 4.80rem; height: 8.32rem; left: -1.04rem; top: -1.09rem; z-index: 1; background-image: url("./static/images/bind-device-v2/image20.png"); background-repeat: no-repeat; background-size: 100% 100%; }
.top-area::after { content: ""; position: absolute; display: block; width: 4.63rem; height: 7.38rem; left: -0.43rem; top: -0.15rem; z-index: 2; background-image: url("./static/images/bind-device-v2/image21.png"); background-repeat: no-repeat; background-size: 100% 100%; }
.bg { position: absolute; left: 0; top: 0; width: 3.76rem; height: 3.60rem; background: linear-gradient(135deg, #7f52fd 0%, #3d78f8 100%); z-index: 0; }
.dial-ring { position: absolute; left: 0.23rem; top: 0.07rem; width: 3.31rem; height: 3.46rem; pointer-events: none; z-index: 2; }
.dial-ring svg { width: 100%; height: 100%; display: block; }
.dial-base { position: absolute; left: 0.23rem; top: 0.07rem; width: 3.31rem; height: 3.46rem; object-fit: contain; pointer-events: none; z-index: 1; }
.ring-track { stroke: rgba(255, 255, 255, 1); stroke-linecap: round; }
.ring-progress { stroke: rgba(36, 156, 247, 1); stroke-linecap: round; transform: rotate(-90deg); transform-origin: 50% 50%; }
.used { position: absolute; left: 50%; top: 1.11rem; transform: translateX(-50%); color: #fff; font-size: 0.18rem; font-weight: 500; line-height: 0.252rem; margin: 0; }
.percent { position: absolute; left: 50%; top: 1.52rem; width: 1.71rem; transform: translateX(-50%); text-align: center; color: #fff; font-size: 0.40rem; font-weight: 400; line-height: 0.56rem; margin: 0; }
.remain { position: absolute; left: 50%; top: 2.23rem; transform: translateX(-50%); color: #fff; font-size: 0.14rem; font-weight: 500; line-height: 0.196rem; margin: 0; }
.info-panel { position: absolute; left: 0; top: 3.77rem; width: 3.75rem; height: 1.56rem; background: #fff; }
.row-divider { position: absolute; left: .15rem; width: 3.45rem; border-bottom: 0.01rem solid #ededed; }
.d1 { top: 4.29rem; } .d2 { top: 4.81rem; } .d3 { top: 5.33rem; }
.label, .value { position: absolute; font-size: 0.14rem; line-height: 0.196rem; }
.label { font-weight: 500; color: #000; } .value { font-weight: 400; color: #000; }
.l1 { left: 0.24rem; top: 3.77rem; } .v1 { left: 1.03rem; top: 3.77rem; }
.l2 { left: 0.24rem; top: 4.29rem; } .v2 { left: 1.03rem; top: 4.29rem; }
.l3 { left: 0.24rem; top: 4.81rem; } .v3 { left: 1.03rem; top: 4.81rem; }
.charge-btn { position: absolute; left: 1.22rem; top: 5.67rem; width: 1.33rem; height: 0.36rem; border: 0; border-radius: 0.08rem; background: #249cf7; color: #fff; font-size: 0.17rem; font-weight: 500; }
</style>



// WEBPACK FOOTER //
// src/newpage/usage.vue